// _entries/pre-template-helpers.ts — Wave 2a "pre-template-helpers" aggregate (Phase 2 of
// plans/bundler-owned-script-load-order.md; concrete in plans/bundler-script-load-order-phase2.md).
//
// The FIRST pre-template-tier Phase-2 fold for a plain-JS leaf. ft-inline-helpers.js loads at footer ~544,
// immediately BEFORE the Run B pre-template aggregate (encounter-map + websocket) and template.js — the
// inline-onclick DOM helpers must exist as window globals before any PHP-generated onclick fires. A
// dedicated 1-member aggregate in that exact slot keeps load order unchanged (it stays above the Run B
// aggregate; it is SEPARATE from it because encounter-map must be Run B's first import).
//
// Member: ft-inline-helpers — pure window attaches at eval (no listeners / no template.js reads). Future
// pre-template-tier leaf inits sharing this slot can join here.
//
// Built by tools/build/build-entry-bundle.mjs (npm run build:pre-template-helpers) ->
// includes/js/dist/pre-template-helpers-bundle.js. The per-member .mjs build + npm run build:ft-inline-helpers
// are KEPT for isolated :watch dev; the old footer tag is kept commented one release as a fallback.

import '../ft-inline-helpers/index';  // footer ~544

import { CREATURE_SIZE_TYPES } from '../shared/creature-size-types';
(window as unknown as { ftCreatureSizeTypes: typeof CREATURE_SIZE_TYPES }).ftCreatureSizeTypes = CREATURE_SIZE_TYPES;
import { creatureFootprint } from '../janus-engine/geometry/creature-box-distance';
(window as unknown as { ftCreatureFootprint: typeof creatureFootprint }).ftCreatureFootprint = creatureFootprint;
